// Session token storage for the passwordless (magic-link) login. Follows the same
// localStorage + CustomEvent pattern used by the NSFW/theme toggles elsewhere in the app.
const SESSION_KEY = "session_token";

export function getSessionToken() {
  return localStorage.getItem(SESSION_KEY);
}

export function setSessionToken(token) {
  localStorage.setItem(SESSION_KEY, token);
  window.dispatchEvent(new CustomEvent("auth-changed"));
}

export function clearSessionToken() {
  localStorage.removeItem(SESSION_KEY);
  window.dispatchEvent(new CustomEvent("auth-changed"));
}
